export default 'Politique de confidentialité (RGPD) | Solution Éco France';
